import React, { useState } from "react";
import styled from "styled-components";
import { Button, ClickAwayListener } from "@mui/material";
import { MapPin, ChevronDown } from "react-feather";

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  padding: 5px;
  background: white;
  border-radius: 10px;
  border: ${(props) =>
    props?.$open ? "2px solid #337ab7" : "1px solid darkgrey"};
  min-width: 100px;

  transition: none;
`;

const FakeButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 36px;

  gap: 2px;
  padding: 5px;
  background: white;
  border-radius: 10px;
  border: 1px solid lightgray;
  min-width: 100px;

  transition: none;
`;

const Item = styled.div`
  display: flex;
  height: 32px;

  width: 100%;
  align-items: center;
  justify-content: flex-start;
  padding: 4px;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  cursor: pointer;

  svg {
    margin-right: 8px;
    height: 12px;
    width: 12px;

    color: ${(props) => (props?.$disabled ? "#337ab7" : "slategrey")};
  }

  span {
    color: ${(props) => (props?.$disabled ? "#337ab7" : "black")};
  }

  &:hover {
    background: #eeeeee50;
  }
`;

const SwitchLocationV2 = ({
  locationList,
  selectedLocationId,
  setSelectedLocationId,
}) => {
  const [open, setOpen] = useState(false);

  const selectedLocation = locationList?.find(
    (l) => l.id === selectedLocationId,
  );

  const handleClick = (id) => {
    setSelectedLocationId(id);
    setOpen(false);
  };

  // Sort the locationList alphabetically by name
  const locationListAlphabetical = locationList?.slice().sort((a, b) => {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  });

  if (locationList?.length === 1) {
    return (
      <FakeButton>
        <MapPin color="black" height={13} width={13} />
        <div style={{ width: 2, minWidth: 2 }} />
        <span style={{ fontSize: 14, fontWeight: 600, color: "black" }}>
          {locationList?.[0]?.name}
        </span>
      </FakeButton>
    );
  }

  return (
    <div style={{ position: "relative" }}>
      <StyledButton onClick={() => setOpen((p) => !p)} $open={open}>
        <MapPin color="black" height={13} width={13} />
        <div style={{ width: 4, minWidth: 4 }} />
        <span style={{ fontSize: 13, fontWeight: 600, color: "black" }}>
          {selectedLocation?.name || "All Locations"}
        </span>
        <div style={{ marginLeft: "auto", width: 4, minWidth: 4 }} />
        <ChevronDown height={15} width={15} color="black" />
      </StyledButton>
      {open && (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <div
            style={{
              minHeight: 100,
              width: 260,
              background: "white",
              borderRadius: 8,
              border: "1px solid slategrey",
              zIndex: 1000,
              position: "absolute",
              top: 40,
              gap: 4,
              padding: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <Item
              disabled={selectedLocationId === null}
              $disabled={selectedLocationId === null}
              onClick={() => handleClick(null)}
            >
              {" "}
              <MapPin />
              <span style={{ fontWeight: "500" }}>All Locations</span>
            </Item>
            {locationListAlphabetical?.map((l) => (
              <Item
                disabled={l.id === selectedLocationId}
                $disabled={l.id === selectedLocationId}
                onClick={() => handleClick(l.id)}
                key={l.name}
              >
                <MapPin />
                <span style={{ fontWeight: 500 }}>{l.name}</span>
              </Item>
            ))}
          </div>
        </ClickAwayListener>
      )}
    </div>
  );
};

export default SwitchLocationV2;
